/**
 * Query keys. Each area starts with one root segment so a live event can
 * invalidate a whole area by prefix (see live.ts). Areas add their own keys
 * under their root; keep the first segment from this list.
 */
export const roots = {
  auth: 'auth',
  public: 'public',
  customer: 'customer',
  ops: 'ops',
  bookings: 'bookings',
  customers: 'customers',
  credits: 'credits',
  invoices: 'invoices',
  payments: 'payments',
  fleet: 'fleet',
  catalog: 'catalog',
  pricing: 'pricing',
  settings: 'settings',
  team: 'team',
  audit: 'audit',
  dashboard: 'dashboard',
  finance: 'finance',
  reports: 'reports',
  content: 'content',
  notifications: 'notifications',
} as const;

export type Root = (typeof roots)[keyof typeof roots];

export const qk = {
  me: () => [roots.auth, 'me'] as const,
  publicCatalog: () => [roots.public, 'catalog'] as const,
  publicContent: (locale: string) => [roots.public, 'content', locale] as const,
  availability: (q: Record<string, unknown>) => [roots.public, 'availability', q] as const,
  quote: (q: unknown) => [roots.public, 'quote', q] as const,
  bookingStatus: (ref: string) => [roots.public, 'status', ref] as const,
  customerMe: () => [roots.customer, 'me'] as const,
  myBookings: () => [roots.customer, 'bookings'] as const,
  myBooking: (ref: string) => [roots.customer, 'booking', ref] as const,
  myCredits: () => [roots.customer, 'credits'] as const,
  myInvoices: () => [roots.customer, 'invoices'] as const,
};
